import * as THREE from 'three';

/**
 * Objects near the camera (ships, rocks, lasers) must draw after the atmosphere pass, which has no
 * depth test; otherwise they get hazed as if they sat at the far end of the view ray.
 */
export const FOREGROUND_ORDER = 10;

export function markForeground(root: THREE.Object3D): void {
  root.traverse((o) => {
    const mesh = o as THREE.Mesh;
    if (!mesh.isMesh) return;
    const mats = Array.isArray(mesh.material) ? mesh.material : [mesh.material];
    for (const m of mats) {
      if (!m.transparent) {
        m.transparent = true;
        m.depthWrite = true;
      }
    }
    if (mesh.renderOrder < FOREGROUND_ORDER) mesh.renderOrder = FOREGROUND_ORDER;
  });
}
